import React from "react";
import { Box, Button, Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const Footer = ({ coeId, labId, labs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { label: "Daily Attendance", path: "/mentor/attendance" },
    { label: "Daily Practice", path: "/mentor/daily-practice" },
    { label: "Practice Notes", path: "/mentor/practice-notes" },
  ];

  const handleNavigation = (path) => {
    navigate(path, { state: { coeId, labId, labs } });
  };

  return (
    <Box
      component="footer"
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      bgcolor="white"
      boxShadow={3}
      sx={{ height: 60, width: "100%" }}
    >
      <Grid container sx={{ borderTop: "1px solid #ccc", height: "100%" }}>
        {navItems.map(({ label, path }, index) => (
          <Grid
            item
            xs={12 / navItems.length}
            key={path}
            sx={{
              borderRight: index < navItems.length - 1 ? "1px solid #ccc" : "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: location.pathname === path ? "#e0e0e0" : "transparent",
            }}
          >
            <Button
              variant="text"
              fullWidth
              sx={{ color: "black", fontWeight: 500 }}
              onClick={() => handleNavigation(path)}
            >
              {label}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Footer;
